const agentIdentities = {
    title: 'Agent identities',
    description: 'Create, verify, and govern the software agents controlled by your account.',
    your_agents: 'Your agents',
    your_agents_description: 'Registration grants no authority until key proof and approval.',
    register: 'Register agent',
    name: 'Agent name',
    purpose: 'Purpose',
    algorithm: 'Signing algorithm',
    public_key: 'Public JWK',
    public_key_description: 'Paste the public JSON Web Key. Your private key never leaves the agent.',
    create: 'Create registration',
    prove_key: 'Prove key possession',
    prove_key_description: 'Sign the exact challenge below with the agent private key.',
    signature: 'Signature (base64url)',
    verify: 'Verify signature',
    empty: 'No agent identities yet.',
    manage: 'Manage',
    credentials: 'Credentials',
    active_keys_one: '{{count}} active key',
    active_keys_other: '{{count}} active keys',
    workers: 'OpenAgent Workers',
    not_connected: 'Not connected',
    approve: 'Approve agent',
    suspend: 'Suspend agent',
    connect_workers: 'Request Workers access',
    approve_workers: 'Approve Workers access',
    revoke_workers: 'Revoke Workers access',
    mailbox: 'Mailbox, calendar, contacts & files',
    connect_mailbox: 'Request mailbox access',
    approve_mailbox: 'Approve mailbox access',
    revoke_mailbox: 'Revoke mailbox access',
    rotate_key: 'Rotate signing key',
    rotate_key_description: 'Add a new public key, prove possession, and make it the only credential accepted for new tokens.',
    new_public_key: 'New public JWK',
    begin_rotation: 'Begin key rotation',
    signing_keys: 'Signing keys',
    signing_keys_description: 'OpenAgent stores public keys only. Private keys remain with the agent.',
    revoke_key: 'Revoke key',
    revoke_key_confirmation_title: 'Revoke signing key?',
    revoke_key_confirmation_description: 'This cannot be undone. Revoking the current signing key also suspends the agent until a verified replacement is activated.',
    load_failed: 'Unable to load agent identities.',
    registration_failed: 'Unable to create the agent registration.',
    verification_failed: 'The key proof could not be verified.',
    rotation_failed: 'Unable to start signing key rotation.',
    activation_failed: 'The new key was verified but could not be activated.',
    revoke_key_failed: 'Unable to revoke this signing key.',
    update_failed: 'Unable to update this agent.',
    agent_email: 'Agent email',
    agent_email_description: 'A stable software-agent address. Forwarding requires a controller-verified destination.',
    address: 'Address',
    forwarding: 'Forwarding',
    verification: 'Verification',
    unrouted: 'Not forwarded',
    forwarding_to: 'Forwarding to {{destination}}',
    forwarding_destination: 'Forwarding destination',
    enable_forwarding: 'Enable forwarding',
    disable_forwarding: 'Disable forwarding',
    verify_destination: 'Cloudflare sent a verification request to {{destination}}. Verify it before activating forwarding.',
    check_verification: 'Check verification',
    email_requires_approval: 'Approve this agent before enabling email forwarding.',
    email_load_failed: 'Unable to load agent email routing.',
    email_provider_unavailable: 'Email routing is not configured or the provider could not complete the request.',
    email_update_failed: 'Unable to update agent email forwarding.',
};
export default agentIdentities;
